import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, ErrorHandler, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { BaseComponent } from 'src/app/base/base.component';
import { Config } from 'src/infrastructure/config';
import { AllGroupsDataSource } from 'src/infrastructure/dataSource/AllGroupsDataSource';
import { Category } from 'src/models/DTO/categeroies/category';
import { CategoriesService } from 'src/services/request/categories/categories.service';
import { GroupsService } from 'src/services/request/groups/groups.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { ProductService } from 'src/services/request/product/product.service';
import { interval } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { ProductTablePricing } from 'src/models/DTO/pricing/productTablePricing';
import { ProductSearchFilter } from 'src/models/DTO/filters/productSearchFilter';

declare var bootstrap: any;

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.css']
})
export class GroupsComponent extends BaseComponent implements OnInit {

  @ViewChild(CdkVirtualScrollViewport)
  virtualScroll!: CdkVirtualScrollViewport;

  private _sorters: { [key: string] : any } = {
    new: 'Най-нови',
    discount: 'Най-голяма отстъпка',
    price: 'Най-ниска цена',
    old: 'Най-стари'
  }
  private _ds?: AllGroupsDataSource;
  private _categories?: Category;
  private _sorter = 'created';
  private _filters: ProductSearchFilter = {filters: []};
  private _searchedText: string = '';
  private _selectedCategory = 'all';
  private _interval? : any;

  selectedOrder = this._sorters.new;
  searchFieldFocused = false;
  noGroups = false;
  constructor(
    private categoriesService: CategoriesService,
    private router: Router,
    private productService: ProductService,
    private imagesServices: ImagesService,
    private groupsService: GroupsService,
    private modalService: NgbModal,
    private cd: ChangeDetectorRef,
    private ls: LocalstorageService
  ) {
    super();
    this._pageTitle = 'groups';
    this.getRootCategories();
  }

  ngOnInit(): void {
    const lastGroupTabId = this.ls.getLocalStorageItem(Config.lsGroupTabKey);
    if (lastGroupTabId !== null) {
      this._selectedCategory = lastGroupTabId;
    }
    const lastSearchText = this.ls.getLocalStorageItem(Config.lastSearchTextKeyGroups);
    if (lastSearchText !== null) {
      this._searchedText = lastSearchText;
    }
    this.loadGroups();
  }


  get selectedCategory() {
    return this._selectedCategory;
  }

  get categories() {
    return this._categories || { data: []};
  }

  get ds() {
    return this._ds;
  }

  get searchedText() {
    return this._searchedText;
  }

  private updateDSInterval() {
    if (this._interval) {
      clearInterval(this._interval)
    }
    this._interval = setInterval(() => {
      this.ds?.items.forEach((item) => {
        if (item) {
          this.ds?.updateExpirationDate(item);
        }
      })
    }, 60000);
  }

  private loadGroups() {
    this.noGroups = true
    this.groupsService.getFilteredGroups(1, 1, this._searchedText, this._sorter, this._filters).subscribe(groups => {
      if (!groups.data.length && this._ds) {
        this._ds!.groupsLength = 0;
        return;
      }
      if (!groups.data.length && !this._searchedText) return;
      this.noGroups = false;
      this._ds = undefined;
      setTimeout(() => {
        this._ds = new AllGroupsDataSource(
          this.groupsService,
          this.imagesServices,
          this.productService,
          groups.meta?.last_page || 0,
          this._searchedText,
          this._sorter,
          this._filters,
          Config.defaultItemsPerPage
        );
        console.log('this._ds', this._ds);
        this.cd.detectChanges(); // required if using ChangeDetectionStrategy.OnPush
      });
      this.updateDSInterval();
    })
  }

  private getRootCategories() {
    this.categoriesService.getAllRootCategories().subscribe(rootCategories => {
        this._categories =
        {
          data: [
            {
              uuid: 'all',
              name: 'Всички'
            }
          ]
        };
        this._categories?.data.push(...rootCategories.data);
    });
  }

  private getSubcategories(rootCategory: string) {
    const depth = Config.technicalCategories.find(tmpUUID => tmpUUID == rootCategory) ? 2 : 1;
    this.categoriesService.getSubcategories(rootCategory, depth).subscribe(categories => {
      let categoriesToFilter = [];
      if (categories.data[0].sub_categories?.length) {
        categories.data.forEach(sCategory => {
          categoriesToFilter.push(...sCategory.sub_categories!)
        })
      }
      else {
        categoriesToFilter.push(...categories.data);
      }
      this._filters.filters.push({key: 'category', value: categoriesToFilter.map(fCategory => fCategory.uuid).join(',')})
      this.loadGroups();

    })

  }


  public goToGroup(groupUUID: string) {
    this.router.navigate(['group/' + groupUUID]);
  }

  onChipClicked(category: string) {
    if (this._ds)  this._ds!.groupsLength = 0;
    this._selectedCategory = category;
    this._filters.filters = [];
    this.ls.setLocalStorageItem(Config.lsGroupTabKey, this._selectedCategory);
    if (this._selectedCategory != 'all') {
      this.getSubcategories(this._selectedCategory);
    }
    else {
      this.loadGroups();
    }
  }

  ngAfterViewInit(): void {
  }

  public getPriceForOnePiece(productTablePricing: ProductTablePricing[]) {
    return productTablePricing.find(pricing => pricing.quantity_to == 1)?.price_per_piece
  }

  getGroupCardCurrentPriceBase(item: any): number {
    return Number(item?.nextPrice) || 0;
  }

  getGroupCardOldPriceBase(item: any): number {
    return Number(item?.priceForOne) || 0;
  }

  shouldShowGroupOldPrice(item: any): boolean {
    return this.getGroupCardOldPriceBase(item) > this.getGroupCardCurrentPriceBase(item);
  }

  public onGroupSearchTextChange(event: any) {
    this._searchedText = event.target.value;
    if (this._searchedText.length < 3) {
      return;
    }
    if (this._searchedText.length >= 3) {
      if (event) {
        event.target.blur();
      }
      this.loadGroups();
    }
  }

  selectOrder(sorterType: string, sortName: string, modal: any) {
    this._sorter = sorterType;
    this.selectedOrder = this._sorters[sortName];
    modal.close();
    this.loadGroups();
    this.virtualScroll.setRenderedRange({start: 0, end: 20})

  }

  onSearchTextChange(event: any) {
    this._searchedText = event.target.value;
    if (this._searchedText && this._searchedText.length >= 3) {
      this.ls.setLocalStorageItem(Config.lastSearchTextKeyGroups, this._searchedText);
    }
  }


  clearSeacrhedText() {
    this._searchedText = '';
    this.ls.setLocalStorageItem(Config.lastSearchTextKeyGroups, this._searchedText);
    this.loadGroups();
  }

  public open(modal: any) {
    this.modalService.open(modal, { size: 'sm',  windowClass: 'loginModal' })
  }

  public resetFocusFromSearch() {
    setTimeout(() => {
      this.searchFieldFocused = false
    }, 0)
  }
}
